import { render, staticRenderFns } from "./InsNeedDel.vue?vue&type=template&id=18b3e9b1&scoped=true&"
import script from "./InsNeedDel.vue?vue&type=script&lang=js&"
export * from "./InsNeedDel.vue?vue&type=script&lang=js&"
import style0 from "./InsNeedDel.vue?vue&type=style&index=0&id=18b3e9b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3e9b1",
  null
  
)

export default component.exports